 (function () {  
    async function insertSectionCartDrawer() {
      if (document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) return

      var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items')
      if (!cartDrawerItems) return

      if (cartDrawerItems.classList.contains('is-empty')) return

      var wrapper = document.createElement('div')
      wrapper.classList.add('cart-drawer-items-wrapper')
      cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems)
      wrapper.appendChild(cartDrawerItems)

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      wrapper.insertAdjacentHTML('beforeend', upsells.innerHTML)
 
      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()  
      }
    }
    insertSectionCartDrawer()

  /*  async function insertSectionCartPage() {
      const cartItems = document.querySelector('cart-items')
      if (!cartItems) return

      const existingUpsells = document.querySelector('#MainContent #cart-drawer-upsell')
      if (existingUpsells) {
        existingUpsells.remove()
      }

      const upsells = document.querySelector('#cart-drawer-upsell-wrapper')
      cartItems.querySelector('.page-width').insertAdjacentHTML('beforeend', upsells.innerHTML)

      if (!document.querySelector('.cart-drawer-upsell-list li')) {
        document.querySelector('#cart-drawer-upsell').remove()  
      }
    }
    insertSectionCartPage() */
    
    window.onChangeKsUpsellVariantSelector = function( select, event) {
      event.preventDefault()
      const imgSrc = select.options[select.selectedIndex].dataset.variantImg

      if (imgSrc) {
        const img = select.closest('.cart-drawer-upsell-list-item').querySelector('.cart-drawer-upsell-list-item-left img')
        img.src = imgSrc
      }
    }

    function listenCartDrawer() {
      const element = document.querySelector('cart-drawer')
      if (!element) return
  
      let timer 
       
      const observer = new MutationObserver((mutations) => { 
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          /* Nothing to refresh if the drawer this feeds is not rendered.

             This theme ships two drawers: Dawn's <cart-drawer> and the maison
             one. Only maison is used — Dawn's measures display:none,
             visibility:hidden, 0x0 on every page. MutationObserver still fires
             for hidden subtrees, so this kept fetching on every cart change to
             update an upsell inside a drawer that cannot be seen: 4 requests at
             54.7 kB per add-to-cart, ~3.1s of request time, all discarded.

             offsetParent is null for a display:none subtree, so this bails on
             maison pages and stays fully active anywhere Dawn's drawer is
             actually rendered. */
          if (!element.offsetParent && getComputedStyle(element).display === 'none') return

          /* Section Rendering API, not the whole page.

             This used to be fetch(window.location.href): the ENTIRE current
             document, ~1.4 MB on a product page, parsed with DOMParser, purely
             to lift #cart-drawer-upsell-wrapper out of it. The observer above
             fires on every cart mutation, so one add-to-cart pulled the page
             three times — ~4.1 MB and the bulk of the wall clock between
             clicking Add to cart and the drawer settling.

             /cart?section_id=cart-drawer returns the same wrapper from the same
             snippet (sections/cart-drawer.liquid is just `render 'cart-drawer'`)
             at ~25 KB. Measured against each other in the same waterfall:
             1,392 kB / 6.25 s vs 24.7 kB / 514 ms. */
          const respoonse = await fetch('/cart?section_id=cart-drawer')
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          document.querySelector('#cart-drawer-upsell-wrapper')
            .replaceWith(newDocument.querySelector('#cart-drawer-upsell-wrapper'))
 
            insertSectionCartDrawer()
        }, 250)
      })

      observer.observe(element, {  
        attributes: true, 
        childList: true, 
        subtree: true
      });
    }
    listenCartDrawer()

    function listenCartPage() {
      const element = document.querySelector('#MainContent .cart__items')
      if (!element) return

      let timer
      
      const observer = new MutationObserver((mutations) => { 
        if (timer) clearTimeout(timer)

        timer = setTimeout(async () => {
          /* Nothing to refresh if the drawer this feeds is not rendered.

             This theme ships two drawers: Dawn's <cart-drawer> and the maison
             one. Only maison is used — Dawn's measures display:none,
             visibility:hidden, 0x0 on every page. MutationObserver still fires
             for hidden subtrees, so this kept fetching on every cart change to
             update an upsell inside a drawer that cannot be seen: 4 requests at
             54.7 kB per add-to-cart, ~3.1s of request time, all discarded.

             offsetParent is null for a display:none subtree, so this bails on
             maison pages and stays fully active anywhere Dawn's drawer is
             actually rendered. */
          if (!element.offsetParent && getComputedStyle(element).display === 'none') return

          /* Section Rendering API, not the whole page.

             This used to be fetch(window.location.href): the ENTIRE current
             document, ~1.4 MB on a product page, parsed with DOMParser, purely
             to lift #cart-drawer-upsell-wrapper out of it. The observer above
             fires on every cart mutation, so one add-to-cart pulled the page
             three times — ~4.1 MB and the bulk of the wall clock between
             clicking Add to cart and the drawer settling.

             /cart?section_id=cart-drawer returns the same wrapper from the same
             snippet (sections/cart-drawer.liquid is just `render 'cart-drawer'`)
             at ~25 KB. Measured against each other in the same waterfall:
             1,392 kB / 6.25 s vs 24.7 kB / 514 ms. */
          const respoonse = await fetch('/cart?section_id=cart-drawer')
          const text = await respoonse.text()
          const newDocument = new DOMParser().parseFromString(text, 'text/html')

          document.querySelector('#cart-drawer-upsell-wrapper')
            .replaceWith(newDocument.querySelector('#cart-drawer-upsell-wrapper'))

            insertSectionCartPage()
        }, 250)
      })

      observer.observe(element, { 
        attributes: true, 
        childList: true, 
        subtree: true
      });
    }
    listenCartPage()
  })();